define('model/unit.model',['require','exports','module','fukit/fukit'],function(require, exports, module) {
  var BaseModel = require('fukit/fukit').BaseModel;

  var UnitModel = BaseModel.extend({
    radioRequests: {
      'models UnitModel': '@constructor',
    },

    urlRoot: '/api/v2/unit',

    defaults: {
      active: false,
    },

    isRootUnit: function() {
      return !this.isNew() && !this.get('parentId');
    },
  });
  module.exports = UnitModel;
});

